// eslint-disable-next-line @typescript-eslint/no-explicit-any
const memoryCache: Map<string, { value: any }> = new Map();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setMemoryCache(key: string, value: any) {
  memoryCache.set(key, { value });
}

export function getMemoryCache(key: string) {
  const entry = memoryCache.get(key);

  if (entry) {
    return entry.value;
  }
  return null;
}
